export default __webpack_public_path__ + "static/media/radish-button-3.09d9fd20.png";